module.exports = __webpack_public_path__ + "media/icons/register-9cd45bc1.png";